export default class InstalationCompanyRelationshipModel {
    idNRelacionEmpresaInstalacion: number | null;
    fkNEmpresa: number | null;
    fkNInstalacion: number | null;
    fkNTipoRelacionEmpresaInstalacion: number | null;

    constructor() {
        this.idNRelacionEmpresaInstalacion = null;
        this.fkNEmpresa = null;
        this.fkNInstalacion = null;
        this.fkNTipoRelacionEmpresaInstalacion = null;
    }


}

